<div class="bpx-dialog kit-lot-filter-dialog">
  <h2 mat-dialog-title>Select Kit Lots</h2>

  <mat-dialog-content>
    <p class="helper-text">
      Choose the kit lots that should remain in this study. Unselected kit lots will be hidden from all tables.
    </p>

    <div class="kit-lot-actions" *ngIf="sortedKitLots.length > 1">
      <button matRipple type="button" class="bpx-btn" (click)="selectAll()">Select All</button>
      <button matRipple type="button" class="bpx-btn" (click)="clearAll()" [disabled]="isApplyDisabled()">Clear All</button>
    </div>

    <div class="kit-lot-list">
      <mat-checkbox
        *ngFor="let kitLot of sortedKitLots"
        [checked]="selectedLots.has(kitLot)"
        (change)="toggleLot(kitLot, $event)">
        {{ kitLot }}
      </mat-checkbox>
      <p class="bpx-empty" *ngIf="!sortedKitLots.length">
        No kit lots were detected in the uploaded files.
      </p>
    </div>

    <div class="bpx-count assay-count-field" *ngIf="isRmqcRunType">
      <label class="bpx-count__label" for="kit-lot-filter-assay-count">Number of Assays</label>
      <input
        id="kit-lot-filter-assay-count"
        class="bpx-count__input"
        type="number"
        min="1"
        integerOnly
        name="numberOfAssays"
        [(ngModel)]="numberOfAssays" />
      <span class="bpx-count__steppers">
        <button type="button" class="bpx-count__step" (click)="stepAssayCount(1)"
          aria-label="Increase the number of assays">
          <mat-icon fontIcon="keyboard_arrow_up"></mat-icon>
        </button>
        <button type="button" class="bpx-count__step" (click)="stepAssayCount(-1)"
          [disabled]="!canDecreaseAssayCount" aria-label="Decrease the number of assays">
          <mat-icon fontIcon="keyboard_arrow_down"></mat-icon>
        </button>
      </span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button matRipple type="button" class="bpx-btn bpx-btn--primary" (click)="applySelection()" [disabled]="isApplyDisabled()">Apply</button>
    <button matRipple type="button" class="bpx-btn" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
